import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { ApiError } from "@/utils/request";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { login, isAuthenticated, user, loading: authLoading } = useAuth();

  useEffect(() => {
    console.log("Login页面 - 认证状态:", isAuthenticated);
    console.log("Login页面 - 认证加载状态:", authLoading);
    console.log("Login页面 - 用户信息:", user);

    if (isAuthenticated && !authLoading) {
      console.log("用户已认证，准备导航到dashboard...");
      setTimeout(() => {
        console.log("执行导航...");
        navigate("/dashboard", { replace: true });
      }, 100); // 添加轻微延迟，确保状态已完全更新
    }
  }, [isAuthenticated, authLoading, user, navigate]);

  // login.tsx
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("开始登录流程");
      const success = await login(username, password);
      console.log("登录成功状态:", success);

      if (success) {
        console.log("登录成功，准备导航");
        // 如果 useEffect 的导航不工作，可以取消注释下面的行
        navigate("/dashboard", { replace: true });
      }
    } catch (err) {
      console.error("登录失败:", err);
      if (err instanceof ApiError) {
        setError(err.message);
      } else {
        setError("登录失败，请检查用户名和密码");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-purple-50 px-4">
      <div className="w-full max-w-md">
        <div className="space-y-8 p-8 sm:p-10 bg-white/90 backdrop-blur rounded-2xl shadow-xl ring-1 ring-black/5">
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="h-28">
              <img
                src="/images/Group 1000004166.png"
                className="h-28 w-auto object-contain"
                alt="溜溜英语"
              />
            </div>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight">
              登录账号
            </h2>
            <p className="text-sm text-gray-500">
              欢迎回来，请使用账户密码登录
            </p>
          </div>

          <form className="space-y-5" onSubmit={handleSubmit}>
            {error && (
              <div className="rounded-lg bg-red-50 p-3 ring-1 ring-red-200">
                <div className="text-sm text-red-700">{error}</div>
              </div>
            )}

            <div className="space-y-4">
              <div>
                <input
                  type="text"
                  required
                  className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-gray-900 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30 disabled:opacity-60 transition"
                  placeholder="请输入用户名"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={loading}
                  autoComplete="username"
                />
              </div>

              <div>
                <input
                  type="password"
                  required
                  className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-gray-900 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30 disabled:opacity-60 transition"
                  placeholder="请输入密码"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button
              type="submit"
              className="mt-2 inline-flex w-full items-center justify-center rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed transition"
              disabled={loading}
            >
              {loading ? "登录中..." : "登录"}
            </button>
          </form>
        </div>

        <div className="mt-6 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} 溜溜英语. All rights reserved.
        </div>
      </div>
    </div>
  );
}
